import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, playState } from "../../lib/api";
import { PhoneFrame } from "../../components/game/PhoneFrame";
import { AlbumGrid } from "../../components/game/AlbumGrid";

export default function Album() {
  const nav = useNavigate();
  const [pid, setPid] = useState(playState.get().patientId);
  useEffect(() => { if (!pid) api.get("/patients").then((r) => setPid(r.data.find((p) => p.is_demo)?.id)); }, [pid]);
  return (
    <PhoneFrame className="overflow-y-auto">
      <div className="min-h-full bg-gradient-to-b from-[#9ED9C9] via-[#F3E3B8] to-[#E7CB93] p-4 pb-10" data-testid="album-page">
        <button data-testid="album-back" onClick={() => nav(-1)} className="flex h-11 items-center gap-2 rounded-full bg-[#0A2540] px-4 text-sm font-bold text-white"><ArrowLeft className="h-4 w-4" />Retour</button>
        <p className="mt-5 text-[10px] font-extrabold tracking-[0.3em] text-[#0F7C7C]">BAOBAB ADVENTURES</p>
        <h1 className="mb-4 font-display text-3xl font-bold text-[#0A2540]">Mon album de séances</h1>
        <AlbumGrid pid={pid} />
      </div>
    </PhoneFrame>
  );
}
